export const saveAs = ( data, filename, mimetype ) => {
	const blob = new Blob([data], { type: mimetype });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	a.remove();
	URL.revokeObjectURL(url);
};